import { Component, type ReactNode } from 'react';

import FreeTextbooksNotFoundPage from 'ms-pages/FreeTextbooks/FreeTextbooksNotFoundPage/FreeTextbooksNotFoundPage';
import { freeTextbooksHomePath } from 'ms-pages/FreeTextbooks/urls';

export default class FreeTextbooksErrorBoundary extends Component<
  { children: ReactNode },
  { caught: boolean }
> {
  override state = {
    caught: false,
  };

  override componentDidCatch() {
    this.setState({ caught: true });
  }

  override render() {
    if (this.state.caught) {
      return <FreeTextbooksNotFoundPage escapePath={freeTextbooksHomePath} />;
    }
    return this.props.children;
  }
}
